// extracted by mini-css-extract-plugin
module.exports = {"root":"IconDirectionsWalk_root__1HJl2"};